import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Helmet } from 'react-helmet';
import FeedbackSection from '../FeedbackSection';
import canUseDOM from '../../util/canUseDOM';
import metrics from '../../browser/metrics';

class VideoWrapper extends Component {
  componentDidMount() {
    $(document).ready(() => {
      $('#wistia-video-bookmarks a').on('click', (e) => {
        metrics.track('click:videos:bookmark', { track_data: e.target.innerHTML });
        document.getElementById('video-wrapper').scrollIntoView({ behavior: 'smooth' });
      });

      $('#wistia-video-bookmarks a').each((index, el) => {
        const time = el.href.split('time=')[1];
        if (time) {
          const timeDec = parseInt(time, 10) / 60;
          const minutes = Math.floor(timeDec);
          const secondsDec = timeDec - minutes;
          const seconds = `${Math.round(secondsDec * 60)}`.padStart(2, 0);
          // eslint-disable-next-line no-param-reassign
          el.text = `[${minutes}:${seconds}] ${el.text}`;
        }
      });
    });
  }

  render() {
    const { video, padding } = this.props;
    let time = '0';

    if (canUseDOM() && window.location.hash) {
      time = window.location.hash.split('?time=')[1];
    }

    return (
      <Fragment>
        <div
          id="video-wrapper"
          className="wistia_responsive_padding"
          style={{ padding, position: 'relative' }}
        >
          <div
            className="wistia_responsive_wrapper"
            style={{ height: '100%', left: '0', position: 'absolute', top: '0', width: '100%' }}
          >
            <div
              className={cx(
              `wistia_async_${video} wistia_embed videoFoam=true`,
              time > 0 ? `autoPlay=true time=${time}` : ''
            )}
              style={{ height: '100%', position: 'relative', width: '100%' }}
            >
              <div
                className="wistia_swatch"
                style={{ height: '100%', left: '0', position: 'absolute', top: '0', width: '100%', overflow: 'hidden' }}
              >
                <img
                  alt="video placeholder"
                  src={`https://fast.wistia.com/embed/medias/${video}/swatch`}
                  style={{ filter: 'blur(5px)', height: '100%', objectFit: 'contain', width: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>
  
        <Helmet>
          <script src="https://fast.wistia.com/embed/medias/pdlav16113.jsonp" async crossOrigin />
          <script src="https://fast.wistia.com/assets/external/E-v1.js" async crossOrigin />
        </Helmet>
  
        <FeedbackSection
          helpful="Was this video helpful?"
          trackingCode="videos"
          trackingData={video}
          useButtons
        />
      </Fragment>
    );
  }
}

VideoWrapper.propTypes = {
  padding: PropTypes.string,
  video: PropTypes.string.isRequired
};

VideoWrapper.defaultProps = {
  padding: '56.25% 0 0 0'
};

export default VideoWrapper;
